export const name = "COUNTIF";
export const summary = `Gets the number of \`TRUE\` values for an expression.`;
export const reference = `
## COUNTIF

Gets the number of \`TRUE\` values for an expression.

\`\`\`
COUNTIF(
  [DISTINCT]
  expression
)
[OVER over_clause]

over_clause:
  { named_window | ( [window_specification] ) }

window_specification:
  [named_window]
  [PARTITION BY partition_expression [, ...] ]
  [ORDER BY expression [ { ASC | DESC }] [, ...] ]
  [window_frame_clause]
\`\`\`

### Description

Gets the number of \`TRUE\` values for an expression.


### Definitions

- \`expression\`: A \`BOOL\` value that represents the expression to evaluate.
- \`DISTINCT\`: To learn more, see Aggregate function calls.
- \`OVER\`: To learn more, see Aggregate function calls.
- \`over_clause\`: To learn more, see Aggregate function calls.
- \`window_specification\`: To learn more, see Window function calls.


### Details

The function signature \`COUNTIF(DISTINCT ...)\` is generally not useful. If you would like to use \`DISTINCT\`, use \`COUNT\` with \`DISTINCT IF\`. For more information, see the \`COUNT\` function.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT COUNTIF(x<0) AS num_negative, COUNTIF(x>0) AS num_positive
FROM UNNEST([5, -2, 3, 6, -10, -7, 4, 0]) AS x;

/*--------------+--------------*
 | num_negative | num_positive |
 +--------------+--------------+
 | 3 | 4 |
 *--------------+--------------*/
\`\`\`



\`\`\`
SELECT
  x,
  COUNTIF(x<0) OVER (ORDER BY ABS(x) ROWS BETWEEN 1 PRECEDING AND 1 FOLLOWING) AS num_negative
FROM UNNEST([5, -2, 3, 6, -10, NULL, -7, 4, 0]) AS x;

/*------+--------------*
 | x | num_negative |
 +------+--------------+
 | NULL | 0 |
 | 0 | 1 |
 | -2 | 1 |
 | 3 | 1 |
 | 4 | 0 |
 | 5 | 0 |
 | 6 | 1 |
 | -7 | 2 |
 | -10 | 2 |
 *------+--------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
